// @core/api/endpoints/audittrail/get_data_subject_access_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DataSubjectAccessRequestResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Get data subject access request
 * Retrieves a DSAR by its unique identifier, including processing status and response data.
 */
export async function GetDataSubjectAccessRequest(
  request_id: string,
  options?: RequestOptions
): Promise<DataSubjectAccessRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/dsar/:request_id`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.get<DataSubjectAccessRequestResponse>(requestPath, { ...requestOptions });
}
